<template>
  <slice
    v-if="isFilled"
    :id="block._key"
    class="block--title container text-center"
    @in="$emit('in')"
    @out="$emit('out')"
  >
    <div class="row-md justify-center slice__inner">
      <div class="col-md-8">
        <portable-text :blocks="block.title" />
      </div>
    </div>
  </slice>
</template>

<script>
import Slice from '@/components/Slices/Slice'
import PortableText from '@/components/RichText/PortableText'

export default {
  name: 'BlockTitle',
  components: {
    Slice,
    PortableText,
  },
  props: {
    block: { type: Object, required: true },
  },
  computed: {
    isFilled() {
      return this.block.title && this.block.title.length > 0
    },
  },
}
</script>

<style lang="scss">
.block--title {
  .title {
    margin-bottom: 0;
  }

  &.row-auto {
    @include mq($from: tablet) {
      padding: 0 calc(var(--spacing) * 3);
      text-align: left;

      .slice__inner {
        justify-content: flex-start;
      }

      .portable-text {
        margin: 0;
      }
    }
  }

  .blocks--gallery & {
    @include mq($until: tablet) {
      text-align: left;
    }
  }
}
</style>
